import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";
import type { ServicesSectionProps, ServicesSectionBox } from "./ServicesSection.d";

export const ServicesSectionPart = (props: ComponentProps<PartData>) => {
    const {
        superTitle,
        title,
        subTitle,
        alignment = "left",
        columns = "2",
        cardStyle = "factbox",
        boxes = [],
        button,
    } = (props.data as ServicesSectionProps) ?? {};

    const cardClass = cardStyle === "card" ? "services-section__card--outline" : "services-section__card--factbox";

    return (
        <section className="services-section">
            <div className="services-section__inner">
                <div className={`services-section__text services-section__text--${alignment}`}>
                    {superTitle && (
                        <span className="services-section__supertitle">{superTitle}</span>
                    )}
                    {title && (
                        <h2 className="services-section__title">{title}</h2>
                    )}
                    {subTitle && (
                        <p className="services-section__subtitle">{subTitle}</p>
                    )}
                    {button && (
                        <div className="services-section__button-wrap">
                            <a
                                href={button.url || "#"}
                                className={["btn", button.style, button.margin].filter(Boolean).join(" ")}
                            >
                                {button.label}
                            </a>
                        </div>
                    )}
                </div>

                {boxes.length > 0 && (
                    <div className={`services-section__grid services-section__grid--cols-${columns}`}>
                        {boxes.map((box: ServicesSectionBox, idx: number) => (
                            <div key={idx} className={`services-section__card ${cardClass}`}>
                                {box.boxTitle && (
                                    <h3 className="services-section__card-title">{box.boxTitle}</h3>
                                )}
                                {box.boxContent && (
                                    <div
                                        className="services-section__card-content"
                                        dangerouslySetInnerHTML={{ __html: box.boxContent }}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default ServicesSectionPart;
